import * as TYPES from './types';

export const patientIdentifierLoaded = (patientIdentifierLabel) => ({
  type: TYPES.LOCALIZED_PT_IDENTIFIER_LOADED_SUCCESS,
  patientIdentifierLabel,
});

